"use client";

import { LegalShell } from "@/components/legal/legal-shell";

export function PrivacyPolicyPage() {
  return (
    <LegalShell title="Kebijakan Privasi GASS" updated="Pembaruan terakhir: 30/10/2023">

      <p>
        Kebijakan Privasi ini merupakan wujud komitmen nyata dari PT Gass.co.id
        Karsa Wesya (<b>&ldquo;Kami&rdquo;</b> atau <b>&ldquo;Gass.co.id&rdquo;</b>)
        untuk menghargai, menjaga dan melindungi setiap data dan informasi pribadi
        pengguna dan pengunjung. Kebijakan Privasi ini juga mengandung penggunaan
        aplikasi dan platform di alamat website Gass.co.id yakni{" "}
        <a href="https://gass.co.id" target="_blank" rel="noopener noreferrer">
          https://gass.co.id
        </a>{" "}
        (<b>&ldquo;Situs&rdquo;</b>).
      </p>

      <p>
        Ketentuan dalam halaman ini mengatur mengenai data-data pengguna yang
        diberikan oleh para pengguna Situs (<b>&ldquo;Anda&rdquo;</b> atau{" "}
        <b>&ldquo;Pengguna&rdquo;</b>) kepada Kami dalam rangka pemanfaatan
        fasilitas, fitur, jasa dan/atau layanan yang Kami tawarkan melalui Situs.
        Ketentuan di bawah ini berlaku untuk seluruh Pengguna Situs tanpa terkecuali
        untuk tunduk dan taat atas ketentuan yang telah ditetapkan.
      </p>

      <p>
        Kebijakan Privasi Gass.co.id ini tunduk dan sesuai dengan Undang-Undang
        Nomor 11 Tahun 2008 tentang Informasi dan Transaksi Elektronik, sebagaimana
        telah diubah dengan Undang-Undang Nomor 19 Tahun 2016 tentang Perubahan Atas
        Undang-Undang Nomor 11 Tahun 2008 tentang Informasi dan Transaksi
        Elektronik, Peraturan Pemerintah Nomor 71 Tahun 2019 tentang Penyelenggaraan
        Sistem dan Transaksi Elektronik, Peraturan Peraturan 20/2016 (seluruhnya
        secara bersama-sama <b>&ldquo;Peraturan ITE&rdquo;</b>) Undang-Undang Nomor
        27 Tahun 2022 tentang Pelindungan Data Pribadi (untuk selanjutnya disebut{" "}
        <b>&ldquo;UU Pelindungan Data Pribadi&rdquo;</b>) dan peraturan terkait
        lainnya yang berlaku di Negara Kesatuan Republik Indonesia. Kebijakan Privasi
        ini menjelaskan jenis-jenis Data Pribadi (sebagaimana didefinisikan di bawah
        ini) yang Kami telah peroleh, kumpulkan dan cara Kami menggunakan, mengolah,
        menganalisis, menyimpan, mengumumkan, mengirimkan, menyebarluaskan, dan
        memusnahkan data pribadi tersebut.
      </p>

      <div>
        Kami dapat memperoleh Data Pribadi mengenai Anda dari berbagai macam sumber.
        Kami dapat mengumpulkan data ini ketika Anda mengakses Situs Kami. Kami
        mengumpulkan Data Pribadi melalui, tetapi tidak terbatas pada, cara-cara
        berikut:
      </div>
      <div>(i) ketika Anda meramban/mengakses Situs Kami dan/atau</div>
      <div>(ii) ketika Anda terhubung dengan Kami melalui media sosial Kami;</div>

      <p>
        Kebijakan ini tidak, bagaimanapun juga, menjelaskan praktik pihak ketiga
        yang dapat mengumpulkan informasi dari Anda ketika Anda berinteraksi dengan
        mereka. Kami menganjurkan Anda untuk bertanya tentang praktik kebijakan
        privasi mereka sebelum menyediakan informasi apapun kepada mereka.
      </p>

      <p>
        Dengan mengakses dan/atau mempergunakan layanan pada Situs, Pengguna
        menyatakan bahwa setiap data dan informasi Pengguna merupakan data yang
        benar, sah, dan akurat, serta Pengguna memberikan persetujuan kepada Kami
        untuk mengumpulkan, menggunakan, mengungkapkan, memindahkan, memproses data
        tersebut sebagaimana tercantum dan diatur dalam Kebijakan Privasi ini.
      </p>

      <p>
        Kami berhak untuk sewaktu-waktu mengubah, menghapus dan menerapkan ketentuan
        baru pada Kebijakan Privasi ini. Setiap perubahan pada Kebijakan Privasi ini
        akan segera berlaku sejak tanggal publikasi ketentuan yang diperbarui
        tersebut di lokasi ini (dapat dilihat melalui:{" "}
        <b>&ldquo;Terakhir Diperbarui pada&rdquo;</b>). Masa berlaku Kebijakan
        Privasi ini akan terus berlaku hingga ada perubahan terbaru.
      </p>

      <p>
        Kami akan memberi Anda pemberitahuan 14 hari kerja sebelumnya apabila ada
        revisi terhadap <b>Kebijakan Privasi</b> ini, sebagai bentuk permintaan
        persetujuan Anda melalui pengumuman pada email atau tautan elektronik.
        Penggunaan Layanan berkelanjutan oleh Anda setelah menerima pemberitahuan
        akan perubahan tersebut dianggap sebagai penerimaan Anda terhadap{" "}
        <b>Kebijakan Privasi</b> yang telah direvisi tersebut. Jika Anda tidak
        menyetujui <b>Kebijakan Privasi</b> yang diubah, Anda harus berhenti
        mengakses dan menggunakan Layanan Gass.co.id (sebagaimana didefinisikan di{" "}
        <b>Syarat dan Ketentuan</b>) dengan ketentuan sebagaimana ditentukan dalam
        bagian 11 tentang Penghapusan Akun dan Pemusnahan Data.
      </p>

      <p>
        Apabila diperlukan /diharuskan oleh hukum dan peraturan perundang-undangan
        yang berlaku, proses hukum, litigasi, dan/atau permintaan dari otoritas
        publik dan pemerintah di dalam atau di luar negara tempat tinggal Anda,
        Gass.co.id dapat mengungkapkan informasi dan Data Pribadi Anda kepada pihak
        /otoritas terkait.
      </p>

      <p>
        Mohon Anda membaca <b>Kebijakan Privasi</b> ini dengan seksama untuk
        memastikan bahwa Anda memahami bagaimana ketentuan <b>Kebijakan Privasi</b>{" "}
        ini Kami berlakukan. <b>Kebijakan Privasi</b> ini mencakup hal-hal sebagai
        berikut:
      </p>

      <ol>
        <li>Perolehan dan Pengumpulan Data Pribadi</li>
        <li>Penggunaan Data Pribadi</li>
        <li>Pengungkapan Data Pribadi</li>
        <li>Penyedia Jasa</li>
        <li>Penyimpanan Data Pribadi</li>
        <li>Keamanan Data Pribadi</li>
        <li>
          Kepatuhan dengan ketentuan Informasi dan Transaksi Elektronik, dan
          Perlindungan Data Pribadi
        </li>
        <li>Hak-Hak dan Persetujuan Pengguna</li>
        <li>Pengumpulan dan penggunaan informasi data non-pribadi</li>
        <li>Hukum Yang Berlaku</li>
        <li>Penghapusan Akun dan Pemusnahan Data</li>
        <li>Bahasa</li>
        <li>Pertanyaan, Keluhan dan Kontak</li>
      </ol>

      <h2>1. Perolehan dan Pengumpulan Data Pribadi</h2>

      <h3>1. Pengumpulan Data Pribadi</h3>
      <ul>
        <li>
          <b>&ldquo;Data Pribadi&rdquo;</b> data tentang orang perseorangan yang
          teridentifikasi atau dapat diidentifikasi secara tersendiri atau
          dikombinasi dengan informasi lainnya baik secara langsung maupun tidak
          langsung melalui sistem elektronik atau nonelektronik, sebagaimana telah
          didefinisikan dalam <b>UU Pelindungan Data Pribadi</b>.
        </li>
        <li>
          <p>
            Kami mengumpulkan informasi dan Data Pribadi Pengguna dengan tujuan
            untuk memproses transaksi Pengguna, mengelola dan memperlancar proses
            penggunaan Situs, serta tujuan-tujuan lainnya selama diizinkan oleh
            peraturan perundang-undangan yang berlaku. Adapun data Pengguna yang
            dikumpulkan adalah pada saat Pengguna:
          </p>
          <ol style={{ listStyle: "lower-alpha" }}>
            <li>
              Membuat atau mengelola akun Gass.co.id, termasuk diantaranya : (a)
              nama depan dan nama belakang Anda, (b) alamat rumah Anda, (c) tanggal
              lahir Anda, (d) alamat surel Anda, dan, hanya apabila sesuai (e) nama
              pengguna dan kata sandi Anda, dan (f) preferensi kontrak, (g) pengenal
              perangkat, (h) alamat Internet Protocol (IP address), (i) informasi
              lokasi, (j) informasi kartu kredit/ debit, (k) informasi profil dimana
              kontak tersebut berada melalui media sosial dan (l) informasi lain
              sebagaimana yang dapat diperlukan secara wajar oleh Kami.
            </li>
            <li>
              Menghubungi Gass.co.id, termasuk melalui layanan konsumen;
            </li>
            <li>Mempergunakan layanan dan fitur yang tersedia pada Situs;</li>
            <li>
              Mengisi data-data pembayaran pada saat Pengguna melakukan aktivitas
              transaksi pembayaran melalui Situs, termasuk namun tidak terbatas pada
              data rekening bank; dan/atau
            </li>
            <li>
              Menggunakan fitur yang membutuhkan izin akses terhadap perangkat
              Pengguna.
            </li>
          </ol>
        </li>
        <li>
          Di yurisdiksi tertentu, Kami dapat meminta identitas yang dikeluarkan
          pemerintah termasuk saat membuat akun nirkabel dan mengaktifkan perangkat
          Anda, untuk tujuan memperluas tujuan komersial, mengelola layanan, atau
          sebagaimana yang diwajibkan oleh hukum dan peraturan perundang-undangan
          yang berlaku.
        </li>
      </ul>

      <h3>
        2. Data Pribadi dan informasi yang dikumpulkan setiap kali Anda menggunakan
        atau mengunjungi Situs Kami
      </h3>
      <ul>
        <li>
          Kami menggunakan layanan yang terpercaya untuk mengumpulkan informasi dan
          Data Pribadi Pengguna pada saat menggunakan layanan Gass.co.id. Kami dapat
          mengumpulkan data teknis tertentu sehubungan dengan penggunaan layanan
          Gass.co.id Anda seperti: alamat Internet Protocol (IP address), situs
          pencari (browser web), informasi halaman situs (web) yang sebelumnya atau
          selanjutnya dilihat, durasi setiap kunjungan/sesi, jumlah klik pada saat
          mengakses situs, identitas perangkat internet atau alamat kontrol akses
          media, dan informasi mengenai produsen, model, dan sistem operasi dari
          perangkat yang Anda gunakan untuk mengakses Situs Kami.
        </li>
        <li>
          Ketika Anda menggunakan atau mengunjungi Situs Kami, informasi tertentu
          juga dapat dikumpulkan secara otomatis dengan menggunakan cookies. Cookies
          adalah berkas data kecil yang tersimpan pada komputer atau perangkat
          seluler Anda. Kami menggunakan cookies untuk melacak aktivitas Pengguna
          dengan tujuan untuk meningkatkan interaksi antarmuka (user interface) dan
          pengalaman Pengguna dan mengingat preferensi penelusuran Anda dalam Situs
          Kami. Sebagian besar perangkat seluler dan peramban internet mendukung
          penggunaan cookies; namun Anda dapat menyesuaikan pengaturan pada
          perangkat seluler atau peramban internet Anda untuk menolak beberapa jenis
          cookies atau cookies spesifik tertentu. Perangkat seluler dan/atau
          peramban Anda juga memungkinkan Anda untuk menghapus cookies apa pun yang
          sebelumnya telah tersimpan. Namun demikian, hal itu dapat mempengaruhi
          fungsi-fungsi yang tersedia pada Situs Kami.
        </li>
        <li>
          Setiap kali Anda menggunakan dan mengakses Situs melalui perangkat
          seluler, Kami akan melacak dan mengumpulkan informasi lokasi geografis
          Anda dalam waktu sebenarnya (real time). Dalam beberapa kasus, Anda akan
          diminta atau diharuskan untuk mengaktifkan Global Positioning System (GPS)
          pada perangkat seluler Anda untuk memungkinkan Kami memberikan Anda
          pengalaman yang lebih baik dalam menggunakan Situs. Anda dapat
          menonaktifkan informasi pelacakan lokasi geografis pada perangkat seluler
          Anda untuk sementara waktu. Namun, hal ini dapat mempengaruhi
          fungsi-fungsi yang tersedia pada Situs.
        </li>
      </ul>

      <h3>3. Informasi yang dikumpulkan dari pihak ketiga</h3>
      <ul>
        <li>
          Kami juga dapat mengumpulkan informasi dan Data Pribadi Anda dari pihak
          ketiga (termasuk, namun tidak terbatas dari afiliasi, agen, mitra,
          otoritas penegak hukum dan peraturan, penyedia jasa teknologi seperti
          situs hosting atau dengan siapa Kami melakukan kerja sama). Dalam kasus
          tersebut, Kami hanya akan mengumpulkan Data Pribadi Anda untuk atau
          sehubungan dengan tujuan yang melibatkan pihak ketiga tersebut atau tujuan
          kerja sama Kami dengan pihak ketiga tersebut (tergantung pada situasinya).
        </li>
        <li>
          Gass.co.id dapat memberikan/ mengungkapkan informasi dan Data Pribadi
          Pengguna tertentu kepada pihak ketiga untuk menyediakan atau meningkatkan
          produk dan layanan Kami, termasuk namun tidak terbatas untuk mengirimkan
          produk atas permintaan Anda, atau untuk membantu memasarkan Gass.co.id
          kepada konsumen, penyediaan layanan sistem pembayaran, layanan sistem
          pengiriman untuk transaksi antara Toko Online dan Pelanggan, keperluan
          Layanan Gass.co.id Market dan layanan kebutuhan lainnya yang terkait. Saat
          Kami melakukan pengungkapan tersebut, Kami meminta pihak ketiga untuk
          melaksanakannya sesuai dengan hukum yang berlaku. Jika Anda menyetujui
          layanan ini, akun Anda akan diatur oleh Gass.co.id dan kebijakan privasi
          operator Anda masing-masing. Penerimaan atau persetujuan Anda terhadap
          Kebijakan Privasi tidak mencakup penerimaan atau persetujuan Anda terhadap
          kebijakan privasi lainnya kecuali secara tegas dinyatakan lain dalam
          Kebijakan Privasi ini. Kami mewajibkan masing-masing entitas yang
          mengoperasikan layanan pihak ketiga memiliki hak yang sah untuk
          mengumpulkan, menggunakan, dan membagikan informasi Anda sebelum
          memberikan informasi apa pun kepada kami.
        </li>
      </ul>

      <h2>2. Penggunaan Data Pribadi</h2>
      <p>
        Anda setuju untuk memberikan informasi dan Data Pribadi sebagaimana dimaksud
        pada butir nomor 1 di atas kepada Kami dan Kami dapat menggunakan informasi
        dan Data Pribadi Anda untuk menyediakan, menjaga, dan meningkatkan layanan
        Kami maupun untuk tujuan lain sepanjang diizinkan oleh hukum dan peraturan
        perundang-undangan yang berlaku, termasuk namun tidak terbatas untuk hal-hal
        sebagai berikut:
      </p>

      <ol>
        <li>
          Memproses segala bentuk permintaan, aktivitas maupun transaksi yang
          dilakukan oleh Pengguna melalui Situs, termasuk untuk memproses, mengelola
          atau memverifikasi identitas Anda.
        </li>
        <li>
          <p>
            Penyediaan fitur-fitur untuk memberikan, mewujudkan, memelihara dan
            meningkatkan produk dan layanan Kami, termasuk namun tidak terbatas
            pada:
          </p>
          <ol style={{ listStyle: "lower-alpha" }}>
            <li>
              Menawarkan, memperoleh, menyediakan, atau memfasilitasi layanan maupun
              produk-produk lainnya melalui Situs;
            </li>
            <li>
              Memenuhi dan memvalidasi pembelian, pemesanan dan/atau permintaan Anda;
            </li>
            <li>
              Memproses pembayaran dari Anda, termasuk otorisasi dan pemrosesan
              perbankan online, transaksi kartu kredit/debit, dan mengirim tanda
              terima kepada Anda;
            </li>
            <li>
              Melakukan kegiatan internal yang diperlukan untuk menyediakan layanan
              pada Situs, seperti pemecahan masalah software, bug, permasalahan
              operasional, melakukan analisis data, pengujian, dan penelitian, dan
              untuk memantau dan menganalisis kecenderungan penggunaan dan aktivitas.
            </li>
            <li>
              <p>
                Membantu Pengguna pada saat berkomunikasi dengan customer service
                Kami, diantaranya namun tidak terbatas pada:
              </p>
              <ol style={{ listStyle: "lower-roman" }}>
                <li>Memeriksa dan mengatasi permasalahan Pengguna;</li>
                <li>
                  Merespon dan mengarahkan pertanyaan, permintaan, dan umpan balik
                  (feedback) Pengguna kepada petugas customer service untuk mengatasi
                  permasalahan Pengguna; dan
                </li>
                <li>
                  Mengawasi dan memperbaiki tanggapan dan kinerja customer service.
                </li>
              </ol>
            </li>
            <li>
              Menghubungi Pengguna melalui email, telepon dan lain-lain, untuk
              membantu dan/atau menyelesaikan proses transaksi maupun proses
              penyelesaian kendala.
            </li>
            <li>
              Menginformasikan kepada Pengguna terkait produk, layanan, promosi,
              studi, survei, berita, perkembangan terbaru, acara dan informasi
              lainnya, baik melalui Situs maupun melalui media lainnya.
            </li>
            <li>
              Melakukan riset pasar atau survei, analisis pemasaran internal,
              aktivitas profil pelanggan, analisis pola dan pilihan pelanggan,
              analisis tren penggunaan dan kegiatan dalam kaitannya dengan Situs
              dan/atau layanan dan demografi Pengguna Kami (berdasarkan anonimisasi).
            </li>
            <li>
              Kegiatan administratif dan pembaruan internal, seperti audit, analisis
              data, pencatatan, daftar kontak, manajemen risiko, keamanan, dan
              lain-lain.
            </li>
            <li>
              Penyimpanan Kami, hosting cadangan (baik untuk pemulihan bencana atau
              lainnya) dari informasi dan Data Pribadi Anda, baik di dalam atau di
              luar negara Anda, dan Anda setuju dan mengizinkan Kami menggunakan dan
              memproses informasi dan Data Pribadi Anda untuk keperluan sebagaimana
              yang diidentifikasi dalam Kebijakan Privasi ini.
            </li>
            <li>
              Menyelidiki dugaan kecurangan, penipuan, pemalsuan atau pelanggaran
              lain terhadap hukum, aturan atau peraturan apa pun, aturan atau
              kebijakan Situs, atau hak pihak ketiga, atau untuk menyelidiki segala
              perilaku yang dicurigai yang Kami anggap tidak patut.
            </li>
            <li>
              Kami juga akan menggunakan informasi dan Data Pribadi untuk memberi
              Anda akses ke dalam dan meningkatkan layanan kami; misalnya, untuk
              membuat antar muka platform Kami lebih mudah digunakan. Kami juga dapat
              menggunakan informasi dan Data Pribadi Anda untuk mempersonalisasi
              layanan untuk Anda serta untuk memberikan materi iklan atau pemasaran
              kepada Anda.
            </li>
            <li>
              Kami juga akan menggunakan informasi dan Data Pribadi untuk
              memfasilitasi transaksi bisnis/korporasi (yang dapat berupa namun tidak
              terbatas pada penggabungan/merger, akuisisi, atau penjualan aset) yang
              melibatkan Kami dan/atau afiliasi Kami.
            </li>
            <li>
              Dalam keadaan tertentu, Kami mungkin perlu untuk menggunakan ataupun
              mengungkapkan informasi dan Data Pribadi Pengguna untuk tujuan
              penegakan hukum atau untuk pemenuhan persyaratan hukum dan peraturan
              yang berlaku, termasuk dalam hal terjadinya sengketa atau proses hukum
              yang melibatkan Pengguna dan Kami.
            </li>
          </ol>
        </li>
      </ol>

      <h2>3. Pengungkapan Data Pribadi</h2>
      <ol>
        <li>
          Kami hanya akan mengungkapkan informasi atau Data Pribadi yang diberikan
          kepada Gass.co.id sesuai kebutuhan untuk pelaksanaan layanan Kami yang
          digunakan Pengguna. Kami pada dasarnya bertindak sebagai SAAS / solusi
          untuk penjual (
          <b>
            <em>&quot;Merchant&quot;</em>
          </b>
          ) sehingga Data Pribadi Pengguna yang ada pada Kami juga diungkapkan
          kepada dan dapat diakses serta disimpan oleh Merchant yang menggunakan
          Gass.co.id yang dengannya Anda melakukan transaksi.
        </li>
        <li>
          <p>
            Selain kepada Merchant yang menggunakan Gass.co.id yang dengannya Anda
            melakukan transaksi, Kami juga dapat mengungkapkan atau membagikan
            informasi dan Data Pribadi Anda sehubungan dengan hal-hal sebagai
            berikut:
          </p>
          <ol style={{ listStyle: "lower-alpha" }}>
            <li>
              Dibutuhkan adanya pengungkapan data kepada mitra atau pihak ketiga
              yang bekerja sama dengan Kami dalam menyajikan layanan pada Situs dan
              memproses segala bentuk aktivitas pada Situs, termasuk proses
              transaksi, verifikasi pembayaran, serta aktivitas lain sehubungan
              dengan layanan pada Situs.
            </li>
            <li>
              Kami dapat mengungkapkan informasi dan Data Pribadi Pengguna kepada
              anak perusahaan atau afiliasi Kami untuk membantu memberikan layanan
              atau melakukan pengolahan data demi pengembangan layanan pada Situs.
              Dalam hal entitas lain mengakuisisi Kami, maka informasi dan Data
              Pribadi yang Kami kumpulkan akan Kami ungkapkan dan alihkan kepada
              entitas tersebut.
            </li>
            <li>
              Diwajibkan untuk diungkapkan berdasarkan hukum dan peraturan
              perundang-undangan yang berlaku, seperti sebagai tanggapan terhadap
              perintah pengadilan. Sepanjang diperbolehkan oleh hukum, jika ada
              permintaan dari aparat penegak hukum atau aparat publik lainnya atau
              jika Kami merasa bahwa pengungkapan tersebut dapat mencegah adanya
              investigasi tindak pidana, memfasilitasi investigasi yang terkait
              dengan keamanan publik, melindungi keamanan atau keutuhan layanan Kami,
              atau membuat Kami dapat mengambil tindakan pencegahan atas kewajiban
              yang mungkin timbul.
            </li>
          </ol>
        </li>
        <li>
          Data yang Kami bagikan akan dianalisis dan Kami akan mencoba membatasi
          informasi berdasarkan pada apa yang benar-benar sesuai dengan kebutuhan
          Layanan. Jika dimungkinkan, Kami akan mencoba menyamarkan atau
          menganonimkan (anonymize) data tersebut sebelum diberikan ke pihak ketiga
          agar privasi dan keamanan terjaga.
        </li>
        <li>
          Saat Anda memberikan izin kepada pihak ketiga untuk menggunakan Akun
          Gass.co.id untuk mengakses atau menggunakan layanan yang disediakan oleh
          pihak ketiga tersebut, penggunaan informasi dan Data Pribadi pengguna oleh
          pihak ketiga tunduk pada syarat dan ketentuan dan/atau kebijakan privasi
          masing-masing pihak ketiga.
        </li>
        <li>
          Kami juga dapat mengungkapkan informasi dan Data Pribadi Anda jika Kami
          beranggapan bahwa pengungkapan tersebut diperlukan untuk tujuan keamanan
          nasional, penegakan hukum, atau masalah kepentingan publik lainnya. Kami
          juga dapat mengungkapkan informasi dan Data Pribadi Anda jika Kami
          beranggapan bahwa pengungkapan diperlukan untuk menegakkan Syarat Dan
          Ketentuan atau melindungi kegiatan operasional, pelaksanaan layanan, atau
          Pengguna Kami. Pengungkapan ini dapat mencakup pemberian informasi
          informasi kepada otoritas publik atau pemerintah. Selain itu, jika terjadi
          reorganisasi, merger, atau penjualan, Kami dapat mengalihkan setiap dan
          semua informasi dan Data Pribadi yang Kami kumpulkan kepada pihak ketiga
          terkait.
        </li>
      </ol>

      <h2>4. Penyedia Jasa</h2>
      <p>
        Gass.co.id membagikan informasi dan Data Pribadi Pengguna dengan perusahaan
        yang menyediakan layanan seperti pemrosesan informasi, penambahan kredit,
        pemenuhan pesanan pelanggan, pengiriman produk kepada Anda, mengelola dan
        meningkatkan data pelanggan, menyediakan layanan pelanggan, menilai
        ketertarikan Anda pada produk dan layanan Kami, dan melakukan penelitian
        pelanggan atau survei kepuasan. Perusahaan-perusahaan ini berkewajiban untuk
        melindungi informasi dan Data Pribadi Anda dan dapat ditemukan di manapun
        Gass.co.id beroperasi.
      </p>

      <h2>5. Penyimpanan Data Pribadi</h2>
      <ol>
        <li>
          Data Pribadi Anda hanya akan disimpan selama diperlukan untuk memenuhi
          tujuan dari pengumpulannya, atau selama penyimpanan tersebut diperlukan
          atau diperbolehkan oleh hukum dan peraturan perundang-undangan yang
          berlaku. Untuk menentukan periode penyimpanan yang sesuai, Kami
          mempertimbangkan jumlah, sifat, dan sensitivitas data pribadi Anda,
          potensi risiko bahaya dari penggunaan atau pengungkapan data pribadi Anda,
          tujuan Kami memproses data pribadi Anda, dan apakah Kami dapat mencapainya
          tujuan melalui cara lain dan persyaratan hukum yang berlaku. Kami juga akan
          menyimpan dan menggunakan informasi pribadi Anda sejauh yang diperlukan
          untuk mematuhi kewajiban hukum kami, menyelesaikan perselisihan, dan
          menegakkan kebijakan kami. Kami akan berhenti menyimpan Data Pribadi, atau
          menghapus maksud dari dikaitkannya Data Pribadi tersebut dengan Anda
          sebagai individu, segera setelah dianggap bahwa tujuan pengumpulan Data
          Pribadi tersebut tidak lagi dibutuhkan dengan menyimpan Data Pribadi dan
          penyimpanan tidak lagi diperlukan untuk tujuan bisnis atau secara hukum.
          Data Pribadi Anda dapat dihapus berdasarkan permintaan (<em>request</em>)
          dari Anda dengan ketentuan bahwa data pada <em>server back-up</em> masih
          tersimpan oleh Gass.co.id.
        </li>
        <li>
          Mohon diperhatikan bahwa masih ada kemungkinan bahwa beberapa informasi
          dan Data Pribadi Anda disimpan oleh pihak lain dengan cara tertentu.
          Informasi yang disampaikan melalui komunikasi antar Pengguna yang
          dilakukan selain melalui penggunaan Situs (seperti melalui panggilan
          telepon, SMS, pesan seluler atau cara komunikasi lainnya) juga dapat
          disimpan dengan beberapa cara. Kami tidak mengizinkan dan mendorong
          penyimpanan Data Pribadi dengan cara demikian dan Kami tidak bertanggung
          jawab kepada Anda untuk hal tersebut. Kami tidak akan bertanggung jawab
          atas penyimpanan Data Pribadi Anda. Anda setuju untuk mengganti rugi,
          membela, dan membebaskan Kami, pejabat, direktur, karyawan, agen, mitra,
          dan afiliasi Kami dari dan terhadap setiap dan segala klaim, kerugian,
          kewajiban, biaya, kerusakan, dan ongkos (termasuk tetapi tidak terbatas
          pada biaya hukum dan pengeluaran biaya ganti rugi penuh) yang dihasilkan
          secara langsung atau tidak langsung dari setiap penyimpanan yang tidak sah
          atas Data Pribadi Anda.
        </li>
      </ol>

      <h2>6. Keamanan Data Pribadi</h2>
      <ol>
        <li>
          Kami akan berusaha dengan prosedur, standar dan pengaturan keamanan yang
          ketat untuk melindungi Data Pribadi Anda yang ada di dalam penguasaan Kami
          atau di bawah kendali Kami. Setelah menerima Data Pribadi Anda, Kami akan
          melakukan pengaturan keamanan yang diperlukan untuk melindungi Data
          Pribadi tersebut sewajarnya dan sesuai dengan situasi yang ada, contohnya,
          Kami melindungi Data Pribadi Anda dengan menggunakan enkripsi. Ketika
          mengungkapkan atau memindahkan Data Pribadi Anda melalui internet, Kami
          akan memberlakukan upaya terbaik untuk melindungi dan mengamankan Data
          Pribadi Anda dari akses, pengumpulan, penggunaan atau pengungkapan oleh
          orang-orang yang tidak berwenang dan dari pengolahan yang bertentangan
          dengan hukum, kehilangan yang tidak disengaja, pemusnahan dan kerusakan
          atau risiko serupa. Namun, dengan menyetujui Kebijakan Privasi ini, Anda
          sepakat bahwa tidak ada transmisi data melalui internet yang bisa dijamin
          sepenuhnya aman dan Anda mengakui bahwa Anda menyampaikan informasi melalui
          internet atas risiko dan kebijakan Anda sendiri. Walau Kami akan berusaha
          sebaik mungkin untuk melindungi Data Pribadi Anda, Anda mengakui bahwa Kami
          tidak dapat menjamin keutuhan dan keakuratan Data Pribadi apa pun yang Anda
          kirimkan melalui Internet, atau menjamin bahwa Data Pribadi tersebut tidak
          akan dicegat, diakses, diungkapkan, diubah atau dihancurkan oleh pihak
          ketiga yang tidak berwenang, karena faktor-faktor di luar kendali Kami.
          Anda bertanggung jawab untuk menjaga rincian akun Anda termasuk username
          dan password dan tidak memberikannya kepada pihak ketiga yang tidak
          berwenang. Kami tidak memiliki kewajiban menanggung penyalahgunaan
          username, password, maupun OTP kecuali sebagaimana yang tercantum dalam
          masing-masing Syarat dan Ketentuan Situs Kami. Anda juga harus selalu
          menjaga dan bertanggung jawab atas keamanan perangkat yang Anda gunakan.
        </li>
        <li>
          Kami merancang, membangun, dan menjalankan sistem Kami untuk bisa
          memastikan setiap informasi atau dokumen yang diunggah dan dikirim oleh
          Pengguna ke Layanan Kami akan disimpan dengan aman dan dikirim secara
          rahasia menggunakan standar keamanan dalam industri informasi elektronik.
        </li>
        <li>Semua data Pengguna disimpan dengan menggunakan jasa yang terpercaya.</li>
        <li>
          Data Pribadi yang dikumpulkan oleh Kami disimpan di wilayah Negara Kesatuan
          Republik Indonesia dan akan tersedia selama Pengguna adalah Pengguna Akun
          Gass.co.id sebagaimana disyaratkan oleh Syarat dan Ketentuan dan Peraturan
          Perundang-undangan yang berlaku mengenai penyimpanan Data Pribadi.
        </li>
      </ol>

      <h2>
        7. Kepatuhan dengan ketentuan Informasi dan Transaksi Elektronik, dan
        Perlindungan Data Pribadi
      </h2>
      <ol>
        <li>
          Dengan menggunakan layanan Gass.co.id, Kami setuju untuk menangani dan
          mengelola Pengumpulan Informasi, Penggunaan Informasi, Pembagian Informasi
          sesuai dengan hukum dan peraturan yang berlaku tentang Informasi Dan
          Transaksi Elektronik, dan Perlindungan Data Pribadi (termasuk namun tidak
          terbatas pada Peraturan ITE). Dengan mendaftar pada Gass.co.id, seluruh
          Pengguna memberikan persetujuan atas informasi dan Data Pribadi Pengguna
          untuk ditangani dalam berbagai cara sebagaimana disebutkan dalam Kebijakan
          Privasi ini, dan Kami menjamin bahwa informasi dan Data Pribadi yang
          disediakan akan ditangani dengan itikad baik dan hanya untuk tujuan-tujuan
          layanan Gass.co.id yang sesuai dengan hukum dan peraturan yang berlaku.
        </li>
        <li>
          Apabila di kemudian hari, seluruh atau sebagian dari Kebijakan Privasi ini
          bertentangan atau melanggar hukum-hukum atau peraturan-peraturan yang
          berlaku, maka Kami akan menyesuaikan bagian Kebijakan Privasi yang
          bertentangan atau melanggar tersebut untuk memenuhi kepatuhan berdasarkan
          hukum dan peraturan yang berlaku.
        </li>
      </ol>

      <h2>8. Hak-Hak dan Persetujuan Pengguna</h2>
      <ol>
        <li>
          Anda berhak untuk melakukan perubahan, pembaruan, penambahan ataupun
          perbaikan terhadap Data Pribadi Anda. Di samping itu, Anda juga dapat
          memperoleh akses terhadap Data Pribadi Anda melalui akun yang Anda
          daftarkan di Situs. Namun, harap perhatikan bahwa Data Pribadi Anda mungkin
          disimpan di sistem cadangan (server back-up) Kami untuk beberapa waktu.
          Selain itu, Anda tidak dapat menghapus informasi yang terkait dengan
          transaksi sebelumnya saat Kami melacak riwayat transaksi.
        </li>
        <li>
          Anda juga memiliki hak untuk meminta akses, meminta salinan terhadap Data
          Pribadi Anda melalui akun yang Anda daftarkan di Situs Kami. Kami dapat
          mengenakan sedikit biaya (jumlah seperti yang diizinkan di bawah hukum yang
          berlaku) untuk menutupi biaya administrasi yang diperlukan dalam memproses
          permintaan Anda untuk mengakses Data Pribadi Anda. Sekalipun demikian, Kami
          berhak untuk mengandalkan pengecualian dan/atau pengecualian hukum apa pun
          untuk mengumpulkan, menggunakan, dan mengungkapkan Data Pribadi Anda.
        </li>
      </ol>

      <h2>9. Pengumpulan dan Penggunaan Informasi Data Non-pribadi</h2>
      <p>
        Kami juga mengumpulkan data dalam bentuk yang tidak dengan sendirinya
        memungkinkan untuk berhubungan langsung dengan individu tertentu. Kami dapat
        mengumpulkan, menggunakan, mengalihkan, dan mengungkapkan data non-pribadi
        untuk tujuan apa pun. Berikut ini adalah beberapa contoh informasi
        non-pribadi yang Kami kumpulkan dan bagaimana Kami dapat menggunakannya, hal
        ini tidak mencakup semua informasi non pribadi:
      </p>
      <ol>
        <li>
          Nama <em>browser</em>;
        </li>
        <li>Tipe perangkat;</li>
        <li>Sistem operasi;</li>
        <li>Layanan internet.</li>
      </ol>

      <h2>10. Hukum Yang Berlaku</h2>
      <p>
        Kebijakan Privasi ini akan diatur oleh dan ditafsirkan sesuai dengan hukum
        Negara Republik Indonesia. Pengguna setuju bahwa tindakan hukum apapun atau
        sengketa yang mungkin timbul dari, berhubungan dengan, atau berada dalam cara
        apapun berhubungan dengan Situs dan/atau Kebijakan Privasi ini akan
        diselesaikan secara eksklusif dalam yurisdiksi Pengadilan Negeri Jakarta
        Selatan.
      </p>

      <h2>11. Penghapusan Akun dan Pemusnahan Data</h2>
      <p>
        Pengguna dapat melakukan penghapusan akun dengan tata cara sebagaimana
        dimaksud dalam tautan (link) berikut:{" "}
        <a
          href="https://gass.co.id/article/cara-menghapus-akun-gass"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://gass.co.id/article/cara-menghapus-akun-gass
        </a>
        .
      </p>
      <p>
        Pengguna dapat menarik persetujuan atas pengumpulan, penggunaan dan/atau
        pengungkapan Data Pribadi Anda yang Kami miliki atau berada di bawah kendali
        Kami dengan menghubungi Gass.co.id Support di{" "}
        <a href="mailto:cs@gass.co.id">cs@gass.co.id</a> dan mengikuti instruksi
        khusus yang diberikan kepada Anda di email balasan dari kami, dan Gass.co.id
        akan memproses permintaan Anda sesuai dengan Kebijakan Privasi ini, Peraturan
        ITE, UU Perlindungan Data Pribadi, undang-undang lain yang berlaku. Namun,
        dengan menarik kembali persetujuan Anda maka Anda memahami bahwa Kami tidak
        dapat terus memberikan Layanan kepada Anda dan Kami mungkin perlu mengakhiri
        hubungan dan/atau kontrak yang Anda miliki dengan Kami dan dengan ketentuan
        bahwa data pada server backup masih tersimpan oleh Gass.co.id.
      </p>

      <h2>12. Bahasa</h2>
      <p>
        Kebijakan Privasi ini dibuat dalam Bahasa Inggris dan Bahasa Indonesia, yang
        kedua versinya akan mengikat Anda dan Kami. Jika terdapat ketidaksesuaian
        antara versi Bahasa Indonesia dan versi Bahasa Inggris, versi Bahasa
        Indonesia yang akan berlaku.
      </p>

      <h2>13. Pertanyaan, Keluhan, dan Kontak</h2>
      <p>
        Dengan menggunakan Situs atau layanan yang Kami sediakan, Anda setuju dengan
        pengumpulan, penggunaan, pengungkapan dan pengolahan Data Pribadi Anda
        sebagaimana diatur dalam Kebijakan Privasi ini. Lebih lanjut, jika Anda
        menggunakan layanan Kami, Kami berhak mengumpulkan, menggunakan,
        mengungkapkan dan memproses Data Pribadi Anda sesuai dengan Kebijakan Privasi
        ini. Jika Anda memiliki pertanyaan, komentar atau masalah, atau memerlukan
        bantuan terkait Kebijakan Privasi ini, peraturan-peraturan Kami, hak Anda,
        dan hubungan Anda dengan Situs Kami, Anda dapat secara langsung menghubungi
        Kami melalui surel pada{" "}
        <a href="mailto:cs@gass.co.id">cs@gass.co.id</a>.
      </p>

      <p>Pembaruan terakhir: 30/10/2023</p>
    </LegalShell>
  );
}
